import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { filter, finalize, Observable, switchMap, take } from 'rxjs';
import { environment } from '../../../environments/environment';
import { getSessionId } from '../../helpers/storageUtils';
import { LoaderService } from '../../services/loader.service';
import { TokenService } from '../services/token.service';
import { RetakeRequest, RetakeResponse } from './retake.models';

@Injectable({
  providedIn: 'root'
})
export class RetakeService {
  private http = inject(HttpClient);
  private tokenService = inject(TokenService);
  private loaderService = inject(LoaderService);

  private readonly retakeEndpoint = `${environment.URL_ACTUALIZAR_LEAD}/retake`;

  /**
   * Fetches the retake data from the orchestrator for motos.
   * @param recordId The ID of the record to retake.
   * @returns An Observable with the retake response.
   */
  getRetakeData(recordId: string): Observable<RetakeResponse> {
    this.loaderService.showLoader();
    const requestBody: RetakeRequest = {
      getRetakeData: true,
      recordId: recordId
    };

    const sessionId = getSessionId().toString();

    // Esperar a que exista un token válido antes de hacer la petición
    return this.tokenService.accessToken$.pipe(
      filter(token => !!token), // Filtrar tokens vacíos
      take(1), // Tomar solo el primer token válido y completar
      switchMap(token => {
        const headers = new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'SESSION_ID': sessionId
        });

        return this.http.put<RetakeResponse>(this.retakeEndpoint, requestBody, { headers });
      }),
      finalize(() => this.loaderService.hideLoader())
    );
  }
}
